<template>
  <div class="acerca-view">
    <header class="hero-banner">
      <img src="/img/homeBanner.jpg" alt="Fondo Tasoar" class="hero-bg-image">
      <div class="overlay"></div>
      <div class="hero-content">
        <h1>Acerca de Tasoar</h1>
        <p class="hero-subtitle">Historia, propósito y valores que nos guían</p>
      </div>
    </header>

    <section class="about-section">
      <div class="container">
        <h2>Nuestra Historia</h2>
        <article class="description-text">
          <p>
            Nacimos con el objetivo de integrar diseño, ingeniería y construcción bajo un mismo enfoque práctico.
            Crecemos junto a nuestros clientes, entregando espacios funcionales y seguros que impulsan su operación.
          </p>
        </article>
      </div>
    </section>

    <section class="purpose-section">
      <div class="container">
        <div class="mv-grid">
          <div class="mv-card">
            <h3>Misión</h3>
            <p>
              Proveer soluciones integrales de diseño y construcción que optimicen tiempos, costos y calidad,
              garantizando seguridad y cumplimiento normativo.
            </p>
          </div>
          <div class="mv-card">
            <h3>Visión</h3>
            <p>
              Ser el socio estratégico preferido para desarrollar proyectos confiables, innovadores y sustentables
              en los sectores habitacional, comercial e industrial.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="values-section">
      <div class="container">
        <h2>Valores</h2>
        <div class="values-grid">
          <div class="value-card">
            <div class="icon"><i class="fa-solid fa-handshake"></i></div>
            <h4>Compromiso</h4>
            <p>Orientación total al cumplimiento de objetivos del cliente.</p>
          </div>
          <div class="value-card">
            <div class="icon"><i class="fa-solid fa-shield-halved"></i></div>
            <h4>Integridad</h4>
            <p>Transparencia y responsabilidad en cada decisión.</p>
          </div>
          <div class="value-card">
            <div class="icon"><i class="fa-solid fa-hammer"></i></div>
            <h4>Calidad</h4>
            <p>Ejecución técnica, materiales adecuados y detalle constructivo.</p>
          </div>
          <div class="value-card">
            <div class="icon"><i class="fa-solid fa-palette"></i></div>
            <h4>Diseño</h4>
            <p>Soluciones funcionales y atractivas para cada contexto.</p>
          </div>
          <div class="value-card">
            <div class="icon"><i class="fa-solid fa-server"></i></div>
            <h4>Innovación</h4>
            <p>Tecnología y procesos que mejoran el desempeño del proyecto.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="objective-section">
      <div class="container">
        <h2>Objetivo</h2>
        <div class="objective-box">
          <p>
            Entregar proyectos integrales que transformen ideas en espacios concretos y rentables,
            asegurando seguridad, calidad y eficiencia en cada fase, desde la planificación hasta la entrega.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AcercadeView'
};
</script>

<style scoped>
.acerca-view {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.hero-banner {
  position: relative;
  height: 320px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}
.hero-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.hero-content {
  position: relative;
  z-index: 2;
  padding: 20px;
}
.hero-content h1 {
  font-size: 2.6rem;
  margin-bottom: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}
.hero-subtitle {
  font-size: 1.2rem;
  font-weight: 300;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

.about-section {
  padding: 60px 0;
  background-color: #ffffff;
  text-align: center;
}
.about-section h2 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}
.description-text {
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
}

.purpose-section {
  padding: 40px 0 60px;
  background-color: #f9f9f9;
}
.mv-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}
.mv-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  flex: 1 1 320px;
  max-width: 480px;
  text-align: left;
}
.mv-card h3 {
  margin-bottom: 10px;
  color: #2c3e50;
}
.mv-card p {
  color: #666;
}

.values-section {
  padding: 40px 0 60px;
  background-color: #ffffff;
  text-align: center;
}
.values-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}
.value-card {
  background: white;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  flex: 1 1 220px;
  max-width: 260px;
  text-align: center;
}
.value-card .icon {
  font-size: 2em;
  margin-bottom: 10px;
  color: #42b983;
}
.value-card h4 {
  margin-bottom: 8px;
  color: #2c3e50;
}
.value-card p {
  color: #666;
}

.objective-section {
  padding: 60px 0 80px;
  background-color: #f9f9f9;
  text-align: center;
}
.objective-box {
  max-width: 800px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 28px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.06);
}
.objective-box p {
  color: #555;
  line-height: 1.8;
}

@media (max-width: 768px) {
  .hero-banner {
    height: 260px;
  }
  .mv-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
  .value-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>